import { defineStore } from 'pinia'
import { legalLinks } from '@/helpers/userData.js'

export const useI18nStore = defineStore('i18n', {
	state: () => ({
		customLanding: {
			lpid: {
				age_selection: {},
				age_selection_mature: {},
				female_funnel: {},
				main_loader: {},
				male_funnel: {},
			},
		},
	}),

	getters: {
		getLanguage() {
			return 'en'
		},
		getCustomLanding(state) {
			return state.customLanding
		},
		getLegalLinks() {
			return legalLinks('en')
		},
	},
})
